import { styled } from '@mui/material/styles';
import { Button, ButtonProps } from "@mui/material";
import { purple } from "@mui/material/colors";

const SubmitButton = styled(Button)<ButtonProps>(({ theme }) => ({
    color: theme.palette.mode == "light"? 'white' : 'black',
    backgroundColor: theme.palette.mode == "light"? "#01d28e":"#1bf5ae",
    '&:hover': {
      backgroundColor: "#02ad76",
    },
  }));
export default SubmitButton;
